import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { EmailTemplateComponent } from './components/template-components/types/email-template/email-template.component';
import { EmailTemplateV2Component } from './components/template-components/types/email-template-v2/email-template-v2.component';
import {
  PropertyRecommendationComponent
} from './components/properties/property-recommendation/property-recommendation.component';
import { MsalGuard } from '@azure/msal-angular';
import { PreviewComponent } from './components/template-components/common/preview/preview.component';
import { TranslateComponent } from './components/template-components/translate/translate-list/translate-list.component';
import { RoleGuard as RoleGuard } from './guards/RoleGuard.guard';
import { ValidTemplateIdGuard } from './guards/ValidTemplateId.guard';
import { TranslateEmailTemplateComponent } from './components/template-components/translate/translate-email-template/translate-email-template.component';
import { ConvertLegacyTemplateComponent } from './components/template-components/common/convert-legacy-template/convert-legacy-template.component';
import { CreateCampaignComponent } from './components/campaign/create-campaign/create-campaign.component';
import { ListCampaignComponent } from './components/campaign/list-campaign/list-campaign.component';
import { EditCampaignComponent } from './components/campaign/edit-campaign/edit-campaign.component';
import { SmsTemplateComponent } from './components/template-components/types/sms-template/sms-template.component';
import { TranslateSmsTemplateComponent } from './components/template-components/translate/translate-sms-template/translate-sms-template.component';
import { WebPushTemplateComponent } from './components/template-components/types/web-push-template/web-push-template.component';
import { PushTemplateComponent } from './components/template-components/types/push-template/push-template.component';
import { TranslateWebPushTemplateComponent } from './components/template-components/translate/translate-web-push/translate-web-push-template.component';
import { TranslatePushTemplateComponent } from './components/template-components/translate/translate-push/translate-push-template.component';
import { ViberTemplateComponent } from './components/template-components/types/viber-template/viber-template.component';
import { RcsTemplateComponent } from './components/template-components/types/rcs-template/rcs-template.component';
import { WhatsappTemplateComponent } from './components/template-components/types/whatsapp-template/whatsapp-template.component';
import { RsaSearchTemplateComponent } from './components/template-components/types/google-templates/rsa-search-template/rsa-search-template.component';
import { TranslateWhatsappTemplateComponent } from './components/template-components/translate/translate-whatsapp/translate-whatsapp-template.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { GenSingleImageTemplateComponent } from './components/template-components/types/google-templates/gen-single-image-template/gen-single-image-template.component';
import { GenVideoTemplateComponent } from './components/template-components/types/google-templates/gen-video-template/gen-video-template.component';
import { PerformanceMaxTemplateComponent } from './components/template-components/types/google-templates/performance-max-template/performance-max-template.component';
import { YoutubeVideoTemplateComponent } from './components/template-components/types/google-templates/youtube-video-template/youtube-video-template.component';
import { MetaSingleImageTemplateComponent } from './components/template-components/types/meta-templates/meta-single-image-template/meta-single-image-template.component';
import { MetaVideoTemplateComponent } from './components/template-components/types/meta-templates/meta-video-template/meta-video-template.component';
import { MetaCarouselTemplateComponent } from './components/template-components/types/meta-templates/meta-carousel-template/meta-carousel-template.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template',
    component: EmailTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template-v2',
    component: EmailTemplateV2Component,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'], hideNavbar: true },
  },
  {
    path: 'sms-template',
    component: SmsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'web-push-template',
    component: WebPushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'push-template',
    component: PushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'whatsapp-template',
    component: WhatsappTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'viber-template',
    component: ViberTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rcs-template',
    component: RcsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rsa-search-template',
    component: RsaSearchTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-single-image-template',
    component: GenSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-video-template',
    component: GenVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'performance-max-template',
    component: PerformanceMaxTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'youtube-video-template',
    component: YoutubeVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-single-image-template',
    component: MetaSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-video-template',
    component: MetaVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-carousel-template',
    component: MetaCarouselTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'properties',
    component: PropertyRecommendationComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'preview',
    component: PreviewComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template/:templateName/:language',
    component: EmailTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template-v2/:templateName/:language',
    component: EmailTemplateV2Component,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'], hideNavbar: true },
  },
  {
    path: 'sms-template/:templateName/:language',
    component: SmsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'web-push-template/:templateName/:language',
    component: WebPushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'push-template/:templateName/:language',
    component: PushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'whatsapp-template/:templateName/:language',
    component: WhatsappTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'viber-template/:templateName/:language',
    component: ViberTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rcs-template/:templateName/:language',
    component: RcsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rsa-search-template/:templateName/:language',
    component: RsaSearchTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-single-image-template/:templateName/:language',
    component: GenSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-video-template/:templateName/:language',
    component: GenVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'performance-max-template/:templateName/:language',
    component: PerformanceMaxTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'youtube-video-template/:templateName/:language',
    component: YoutubeVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-single-image-template/:templateName/:language',
    component: MetaSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-video-template/:templateName/:language',
    component: MetaVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-carousel-template/:templateName/:language',
    component: MetaCarouselTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template/:templateName',
    component: EmailTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'email-template-v2/:templateName',
    component: EmailTemplateV2Component,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'], hideNavbar: true },
  },
  {
    path: 'sms-template/:templateName',
    component: SmsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'web-push-template/:templateName',
    component: WebPushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'push-template/:templateName',
    component: PushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'whatsapp-template/:templateName',
    component: WhatsappTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'viber-template/:templateName',
    component: ViberTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rcs-template/:templateName',
    component: RcsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'rsa-search-template/:templateName',
    component: RsaSearchTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-single-image-template/:templateName',
    component: GenSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'gen-video-template/:templateName',
    component: GenVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'performance-max-template/:templateName',
    component: PerformanceMaxTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'youtube-video-template/:templateName',
    component: YoutubeVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-single-image-template/:templateName',
    component: MetaSingleImageTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-video-template/:templateName',
    component: MetaVideoTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'meta-carousel-template/:templateName',
    component: MetaCarouselTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'translate-list/:idcustom',
    component: TranslateComponent,
    canActivate: [MsalGuard, RoleGuard, ValidTemplateIdGuard],
    data: { allowedRoles: ['Administrator', 'User'] },
  },
  {
    path: 'convert-template',
    component: ConvertLegacyTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'convert-template',
    component: ConvertLegacyTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-email-template/:templateName/:language',
    component: TranslateEmailTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-sms-template/:templateName/:language',
    component: TranslateSmsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-web-push-template/:templateName/:language',
    component: TranslateWebPushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-push-template/:templateName/:language',
    component: TranslatePushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-whatsapp-template/:templateName/:en',
    component: TranslateWhatsappTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-email-template/:templateName/',
    component: TranslateEmailTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-sms-template/:templateName/',
    component: TranslateSmsTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-web-push-template/:templateName/',
    component: TranslateWebPushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-push-template/:templateName/',
    component: TranslatePushTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'translate-whatsapp-template/:templateName/',
    component: TranslateWhatsappTemplateComponent,
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
  },
  {
    path: 'campaign',
    canActivate: [MsalGuard, RoleGuard],
    data: { allowedRoles: ['Administrator', 'User', 'Translator'] },
    children: [
      { path: 'new', component: CreateCampaignComponent },
      { path: 'edit', component: EditCampaignComponent },
      { path: 'list', component: ListCampaignComponent }
    ]
  },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }
];
